import { createRouter, createWebHistory } from 'vue-router';
import Profile from '@/components/Profile.vue';
import Services from '@/components/Services.vue';
import Reviews from '@/components/Reviews.vue';
import ContactUs from '@/components/ContactUs.vue';
import Home from '@/components/Home.vue'; // Create this if you don’t have it

const routes = [
  { path: '/', component: Home },
  { path: '/profile', component: Profile },
  { path: '/services', component: Services },
  { path: '/reviews', component: Reviews },
    { path: '/contact', component: ContactUs },

];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
